import * as d3ease from 'd3-ease';

// Chord layout
export const NODE_THICKNESS = 15;

// Label font size
export const MIN_LABEL_FONT_SIZE = 10;
export const MAX_LABEL_FONT_SIZE = 16;

// Initial animation durations and delays
export const RIBBON_INITIAL_ANIM_DURATION = 1500;
export const RIBBON_INITIAL_ANIM_DELAY_MIN = 1200;
export const RIBBON_INITIAL_ANIM_DELAY_RANGE = 500;

export const NODELABEL_INITIAL_ANIM_DURATION = 800;
export const NODELABEL_INITIAL_ANIM_DELAY_RANGE = 1000;

export const TRIPBAR_INITIAL_ANIM_DURATION = 800;
export const TRIPBAR_INITIAL_ANIM_DELAY_MIN = 1500;
export const TRIPBAR_INITIAL_ANIM_DELAY_RANGE = 1000;

export const TRIPBARTEXT_INITIAL_ANIM_DURATION = 1000;
export const TRIPBARTEXT_INITIAL_ANIM_DELAY = 1500;

// Update animation durations and delays
export const SELECTION_ANIM_DURATION = 500;
export const REORDER_ANIM_DURATION = 1000;
export const ZOOM_ANIM_DURATION = 750;

// The graph unfurling left to right when Nora mode opens.
export const UNFURL_ANIM_DURATION = 10000;

// Update animation ease
export const DEFAULT_EASE = d3ease.easeQuad;

// The person/trip captions in the middle of the chord diagram. The font size is
// needed as a number (not just css) because the filter icon on the "filtered"
// line is a shape, and so has to be sized in user units.
export const CAPTION_FONT_SIZE = 30;

// The page background, duplicated from .background_blue in App.css. Constant
// is used for d3 blending to simulate components with reduced opacity.
export const BACKGROUND_COLOR = "#282c34";

// The voyager Nora mode is named after, matched against the names in the sheet.
export const NORA_NAME = "Nora";
